<!--
 * @Author: wang peng
 * @Description: 历史订单列表  
-->
<template>
  <scroll-layout class="thirdConnectionPile-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'order:third:order:export'" type="plain" @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>
<script>
  import { code, getLastTime, offlineExport } from '@/utils';
  import { orderPage, barrierPage } from '@/service/apis';

  export default {
    name: 'thirdOrderList',
    components: {},
    inject: ['reload'],
    data() {
      return {
        searchParams: {
          date: [], //
          gunId: '', //
          startChargingTimeStart: '', //
          startChargingTimeEnd: '', //
          userAccount: '', //
          stationId: '', //
          tradeSeq: '', //
          discountNo: '',
          recordIds: [],
        },
        stationIdData: [],
        tableTitle: '订单列表',
        tableData: [],
        tableOperateButtons: [
          {
            id: '2',
            enabled: () => code('order:third:order:detail'),
            text: '详情',
            handleClick: (btn, { row }) => {
              this.$router.push({
                path: '/orderManagement/thirdOrder/Detail',
                query: { recordId: row.recordId, gunCode: row.gunCode },
              });
            },
          },
        ], // 列表操作
        tableColumns: [
          { label: '充电单号', prop: 'tradeSeq', minWidth: '200px', id: 0 },
          { label: '电站名称', prop: 'stationName', minWidth: '200px', id: 38 },
          { label: '终端ID', prop: 'gunId', minWidth: '180px', id: 37 },
          {
            label: '充电用户',
            prop: 'nickName',
            minWidth: '220px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span>
                    {row.userAccount}({row.nickName})
                  </span>
                );
              },
            },
            id: 1,
          },
          { label: '电量(度)', prop: 'chargedPowerOri', minWidth: '120px', id: 2 },
          { label: '服务费(元)', prop: 'serviceAmount', minWidth: '120px', id: 39 },
          { label: '电费(元)', prop: 'chargedAmount', minWidth: '120px', id: 40 },
          { label: '订单金额(元)', prop: 'totalAmount', minWidth: '120px', id: 3 },
          { label: '订单状态', prop: 'tradeStatusName', minWidth: '180px', id: 41 },
          { label: '订单开始时间', prop: 'startTime', minWidth: '150px', id: 12 },
          { label: '订单结束时间', prop: 'endTime', minWidth: '150px', id: 13 },
          {
            label: '订单结束原因',
            prop: 'stopChargeReasonName',
            minWidth: '150px',
            id: 35,
          },
          { label: '结算时间', prop: 'tradeTime', minWidth: '150px', id: 42 },
          {
            label: '支付状态',
            prop: 'payStatusName',
            minWidth: '150px',
            id: 33,
          },
          { label: '微信商户', prop: 'mchName', minWidth: '150px', id: 43 },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
      };
    },
    created() {
      // 页面跳转传参
      if (this.$route.query.data) {
        const query = JSON.parse(this.$route.query.data);
        console.log('query+++', query);
        if (query.userCardCouponId && query.userCardCouponId !== null) {
          this.searchParams.discountNo = query.userCardCouponId;
        }

        if (query.recordIds && query.recordIds !== null) {
          this.searchParams.recordIds = query.recordIds;
        }
      }

      // 近30天初始化时间
      if (this.searchParams.recordIds && this.searchParams.recordIds.length) {
        this.searchParams.date = [];
        this.searchParams.startChargingTimeStart = '';
        this.searchParams.startChargingTimeEnd = '';
      } else {
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);
        this.searchParams.date = [startDate, endDate];
        this.searchParams.startChargingTimeStart = startDate;
        this.searchParams.startChargingTimeEnd = endDate;
      }

      this.requestStationData();
      this.requestList();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '开始充电 ',
            placeholder: '请选择充电时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '用户账号',
            placeholder: '请输入用户账号',
          },

          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            remote: true,
            comName: 'YkcDropdown',
            key: 'stationId',
            label: '电站名称',
            placeholder: '请输入电站名称',
            data: this.stationIdData,
          },
          {
            comName: 'YkcInput',
            key: 'gunId',
            label: '终端ID',
            placeholder: '请输入终端ID',
          },
        ];
      },
    },
    methods: {
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'hm_third_order',
          jsonNode: {
            ...this.searchParams,
          },
        });
      },

      /**
       * 获取归属电站数据
       */
      requestStationData() {
        barrierPage
          .findThirdStationList({})
          .then(res => {
            console.log('获取归属电站数据+++++', res);
            this.stationIdData = res.map(item => ({
              id: item.stationId,
              name: item.stationName,
            }));
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        console.log('searchData++++', searchData);
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, searchData);

        if (searchData.date && searchData.date.length > 0) {
          [this.searchParams.startChargingTimeStart, this.searchParams.startChargingTimeEnd] =
            searchData.date;
        }
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        console.log('清空查询', form);
        Object.assign(this.searchParams, form);

        // 近30天初始化时间
        const startDate = getLastTime('yyyy-MM-dd', 30);
        const endDate = getLastTime('yyyy-MM-dd', 0);

        this.searchParams.date = [startDate, endDate];
        this.searchParams.startChargingTimeStart = startDate;
        this.searchParams.startChargingTimeEnd = endDate;
      },
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        orderPage
          .thirdPartyChargingOrderPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-checkbox .icon-check {
    top: 7px;
  }

  .thirdConnectionPile-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }
        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }
        .cell .status-red {
          color: #d0021b;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  ::v-deep.customForm .el-form-item,
  ::v-deep.customForm .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
</style>
